import {
    faEdit,
    faFileExcel,
    faPlus,
    faTrash,
    faExclamation,
    faSearch
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import React, { useEffect, useState } from "react";

import { toast, ToastContainer } from "react-toastify";

import {
    getProductos,
    guardarProducto,
    actualizarProducto,
    eliminarProducto
} from "../../../services/productoservice";

import { getCategorias } from "../../../services/categoriaservice";

import XLSX from 'xlsx-js-style';

import "./Producto.css";

export default function Producto() {

    const userData = JSON.parse(localStorage.getItem('user'));

    const [modalNuevoOpen, setModalNuevoOpen] = useState(false);

    const [deleteModalOpen, setDeleteModalOpen] = useState(false);

    const [productos, setProductos] = useState([]);

    const [categorias, setCategorias] = useState([]);

    const [busqueda, setBusqueda] = useState("");

    const [producto, setProducto] = useState({
        idproducto: 0,
        codigo: '',
        nombre: '',
        marca: '',
        idcategoria: '',
        stock: '',
        stockminimo: '',
        costo: '',
        precioventa: '',
        estado_producto: 'Disponible',
        imagen: null
    });

    const cargarProductos = async () => {

        try {

            const data = await getProductos();

            setProductos(data);

        } catch (error) {

            console.error(error);

            toast.error("Error cargando productos");
        }
    };

    const cargarCategorias = async () => {

        try {

            const data = await getCategorias();

            setCategorias(data);

        } catch (error) {

            console.error(error);

            toast.error("Error cargando categorías");
        }
    };

    const productosFiltrados = productos.filter((item) => {

        const texto = busqueda.toLowerCase();

        return (
            item.codigo?.toLowerCase().includes(texto) ||
            item.nombre?.toLowerCase().includes(texto) ||
            item.marca?.toLowerCase().includes(texto) ||
            item.nombre_categoria?.toLowerCase().includes(texto)
        );
    });

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!producto.codigo) {
            toast.error("Ingrese código");
            return;
        }

        if (!producto.nombre) {
            toast.error("Ingrese artículo");
            return;
        }

        try {

            const datosFinales = {
                ...producto,
                idusuario: userData.idusuario
            };

            let result;

            if (producto.idproducto === 0) {

                result = await guardarProducto(datosFinales);

            } else {

                result = await actualizarProducto(datosFinales);
            }

            if (result.status === "success") {

                toast.success("Guardado correctamente");

                setModalNuevoOpen(false);

                cargarProductos();

            } else {

                toast.error("Error operación");
            }

        } catch (error) {

            console.error(error);

            toast.error("Error servidor");
        }
    };

    const handleEdit = (item) => {

        setProducto({
            idproducto: item.idproducto,
            codigo: item.codigo,
            nombre: item.nombre,
            marca: item.marca,
            idcategoria: item.idcategoria,
            stock: item.stock,
            stockminimo: item.stockminimo,
            costo: item.costo,
            precioventa: item.precioventa,
            estado_producto: item.estado_producto,

            // conservar imagen actual
            imagen: item.imagen
        });

        setModalNuevoOpen(true);
    };

    const borrarProducto = async () => {

        try {

            const result = await eliminarProducto(producto);

            if (result.status === "success") {

                toast.success("Producto eliminado");

                setDeleteModalOpen(false);

                cargarProductos();
            }

        } catch (error) {

            console.error(error);

            toast.error("Error servidor");
        }
    };

    const descargarExcel = () => {

        const datos = productos.map(p => ({
            'ID': p.idproducto,
            'Artículo': p.nombre,
            'Código': p.codigo,
            'Marca': p.marca,
            'Categoría': p.nombre_categoria,
            'Stock': p.stock,
            'Stock Min.': p.stockminimo,
            'Costo': p.costo,
            'Precio Venta': p.precioventa,
            'Estado': p.estado_producto
        }));

        const ws = XLSX.utils.json_to_sheet(datos);

        const wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(wb, ws, "Productos");

        XLSX.writeFile(wb, "Productos.xlsx");
    };

    useEffect(() => {

        cargarProductos();

        cargarCategorias();

    }, []);

    return (

        <div className="main-content">

            <ToastContainer />

            {/* HEADER */}
            <div className='nuevo-container'>

                <div className="search-wrapper">

                    <FontAwesomeIcon
                        icon={faSearch}
                        className="search-icon"
                    />

                    <input
                        className="search-input"
                        placeholder="Buscar producto..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />

                </div>

                <div className="header-actions">

                    <button
                        className="btnExcel"
                        onClick={descargarExcel}
                    >
                        <FontAwesomeIcon icon={faFileExcel} />
                        Reporte
                    </button>

                    <button
                        className='nuevo'
                        onClick={() => {

                            setProducto({
                                idproducto: 0,
                                codigo: '',
                                nombre: '',
                                marca: '',
                                idcategoria: '',
                                stock: '',
                                stockminimo: '',
                                costo: '',
                                precioventa: '',
                                estado_producto: 'Disponible',
                                imagen: null
                            });

                            setModalNuevoOpen(true);

                        }}
                    >
                        <FontAwesomeIcon icon={faPlus} />
                        Nuevo Producto
                    </button>

                </div>

            </div>

            {/* TABLA */}
            <div className="table-container">

                <table className="table">

                    <thead>

                        <tr>
                            <th>ID</th>
                            <th>Imagen</th>
                            <th>Artículo</th>
                            <th>Código</th>
                            <th>Marca</th>
                            <th>Categoría</th>
                            <th>Stock</th>
                            <th>Stock Min.</th>
                            <th>Costo</th>
                            <th>Precio</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>

                    </thead>

                    <tbody>

                        {productosFiltrados.length > 0 ? (

                            productosFiltrados.map((item) => (

                                <tr key={item.idproducto}>

                                    <td>{item.idproducto}</td>

                                    <td>
                                        {item.imagen ? (
                                            <img
                                                src={`https://jm.komerzy.com/backend/${item.imagen}`}
                                                alt="producto"
                                                width="60"
                                                height="60"
                                                style={{ objectFit: 'cover', borderRadius: '8px' }}
                                            />
                                        ) : (
                                            <span>Sin imagen</span>
                                        )}
                                    </td>

                                    {/* ✔ ARTÍCULO primero */}
                                    <td className="nombre-resaltado">
                                        {item.nombre}
                                    </td>

                                    {/* ✔ CÓDIGO después */}
                                    <td>{item.codigo}</td>

                                    <td>{item.marca}</td>
                                    <td>{item.nombre_categoria}</td>
                                    <td>{item.stock}</td>
                                    <td>{item.stockminimo}</td>
                                    <td>S/ {item.costo}</td>
                                    <td>S/ {item.precioventa}</td>
                                    <td>{item.estado_producto}</td>

                                    <td style={{ textAlign: "center" }}>

                                        <button
                                            className='editar'
                                            onClick={() => handleEdit(item)}
                                        >
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>

                                        <button
                                            className='eliminar'
                                            onClick={() => {
                                                setProducto(item);
                                                setDeleteModalOpen(true);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>

                                    </td>

                                </tr>

                            ))

                        ) : (

                            <tr>
                                <td
                                    colSpan="12"
                                    style={{
                                        textAlign: "center",
                                        padding: "20px"
                                    }}
                                >
                                    No hay productos
                                </td>
                            </tr>

                        )}

                    </tbody>

                </table>

            </div>

            {/* MODAL */}
            {modalNuevoOpen && (

                <div
                    className="modalOverlay"
                    onClick={() => setModalNuevoOpen(false)}
                >

                    <div
                        className="modalWindow"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <div className="modalHeader">
                            <h2>Producto</h2>
                        </div>

                        <div className="modalBody">

                            <div className="modalRow">

                                <input
                                    className="input-modal"
                                    placeholder="Código"
                                    value={producto.codigo}
                                    onChange={(e) =>
                                        setProducto({
                                            ...producto,
                                            codigo: e.target.value
                                        })
                                    }
                                />

                                <input
                                    className="input-modal"
                                    placeholder="Artículo"
                                    value={producto.nombre}
                                    onChange={(e) =>
                                        setProducto({
                                            ...producto,
                                            nombre: e.target.value
                                        })
                                    }
                                />

                            </div>

                            <div className="modalRow">

                                <input
                                    className="input-modal"
                                    placeholder="Marca"
                                    value={producto.marca}
                                    onChange={(e) =>
                                        setProducto({
                                            ...producto,
                                            marca: e.target.value
                                        })
                                    }
                                />

                                <select
                                    className="input-modal"
                                    value={producto.idcategoria}
                                    onChange={(e) =>
                                        setProducto({
                                            ...producto,
                                            idcategoria: e.target.value
                                        })
                                    }
                                >

                                    <option value="">
                                        Seleccione categoría
                                    </option>

                                    {categorias.map((cat) => (

                                        <option
                                            key={cat.idcategoria}
                                            value={cat.idcategoria}
                                        >
                                            {cat.categoria}
                                        </option>

                                    ))}

                                </select>

                            </div>

                            <div className="modalRow">

                                <input
                                    className="input-modal"
                                    type="number"
                                    placeholder="Stock"
                                    value={producto.stock}
                                    onChange={(e) =>
                                        setProducto({
                                            ...producto,
                                            stock: e.target.value
                                        })
                                    }
                                />

                                <input
                                    className="input-modal"
                                    type="number"
                                    placeholder="Stock mínimo"
                                    value={producto.stockminimo}
                                    onChange={(e) =>
                                        setProducto({
                                            ...producto,
                                            stockminimo: e.target.value
                                        })
                                    }
                                />

                            </div>

                            <div className="modalRow">

                                <input
                                    className="input-modal"
                                    type="number"
                                    step="0.01"
                                    placeholder="Costo"
                                    value={producto.costo}
                                    onChange={(e) =>
                                        setProducto({
                                            ...producto,
                                            costo: e.target.value
                                        })
                                    }
                                />

                                <input
                                    className="input-modal"
                                    type="number"
                                    step="0.01"
                                    placeholder="Precio venta"
                                    value={producto.precioventa}
                                    onChange={(e) =>
                                        setProducto({
                                            ...producto,
                                            precioventa: e.target.value
                                        })
                                    }
                                />

                            </div>

                            {/* ESTADO */}
                            <div className="modalRow">

                                <select
                                    className="input-modal"
                                    value={producto.estado_producto}
                                    onChange={(e) =>
                                        setProducto({
                                            ...producto,
                                            estado_producto: e.target.value
                                        })
                                    }
                                    style={{ height: "42px" }}
                                >
                                    <option value="Disponible">Disponible</option>
                                    <option value="Agotado">Agotado</option>
                                </select>

                            </div>


                            {/* IMAGEN (ABAJO, EN SU PROPIA FILA) */}
                            <div className="modalRow" style={{ alignItems: "center" }}>

                                {/* PREVIEW IZQUIERDA */}
                                <div>
                                    {producto.imagen ? (
                                        <img
                                            src={
                                                typeof producto.imagen === "string"
                                                    ? `https://jm.komerzy.com/backend/${producto.imagen}`
                                                    : URL.createObjectURL(producto.imagen)
                                            }
                                            alt="Producto"
                                            style={{
                                                width: "90px",
                                                height: "90px",
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                                border: "1px solid #ddd"
                                            }}
                                        />
                                    ) : (
                                        <div
                                            style={{
                                                width: "90px",
                                                height: "90px",
                                                border: "1px dashed #ccc",
                                                borderRadius: "8px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontSize: "12px",
                                                color: "#999"
                                            }}
                                        >
                                            Sin imagen
                                        </div>
                                    )}
                                </div>

                                {/* BOTÓN / INPUT DERECHA */}
                                <div style={{ flex: 1 }}>

                                    <input
                                        className="input-modal"
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) =>
                                            setProducto({
                                                ...producto,
                                                imagen: e.target.files[0]
                                            })
                                        }
                                    />

                                    <p style={{ fontSize: "12px", color: "#777", marginTop: "6px" }}>
                                        Formatos: JPG, PNG
                                    </p>

                                </div>

                            </div>

                        </div>

                        <div className="modalFooter">

                            <button
                                className="modalBtn btnCancelar"
                                onClick={() => setModalNuevoOpen(false)}
                            >
                                Cancelar
                            </button>

                            <button
                                className="modalBtn btnGuardar"
                                onClick={handleSubmit}
                            >
                                Guardar
                            </button>

                        </div>

                    </div>

                </div>

            )}

            {/* DELETE */}
            {deleteModalOpen && (

                <div
                    className="modalOverlay"
                    onClick={() => setDeleteModalOpen(false)}
                >

                    <div
                        className="modalWindow deleteStyle"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <div className="deleteHeader">

                            <button
                                onClick={() => setDeleteModalOpen(false)}
                                className="deleteCloseX"
                            >
                                ×
                            </button>

                        </div>

                        <div className="deleteIconContainer">

                            <div className="deleteIconCircle">

                                <FontAwesomeIcon icon={faExclamation} />

                            </div>

                        </div>

                        <div className="deleteBodyContent">

                            <h3 className="deleteTitle">
                                ¿Eliminar producto?
                            </h3>

                            <p className="deleteText">
                                El producto <b>{producto?.nombre}</b> será eliminado permanentemente.
                            </p>

                            <div className="deleteActions">

                                <button
                                    className="btnCancelGhost"
                                    onClick={() =>
                                        setDeleteModalOpen(false)
                                    }
                                >
                                    Cancelar
                                </button>

                                <button
                                    className="btnConfirmFilled"
                                    onClick={borrarProducto}
                                >
                                    Confirmar
                                </button>

                            </div>

                        </div>

                    </div>

                </div>

            )}

        </div>

    );
}